import { useMutation, type UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { authClient, betterAuthErrorText } from "lib/auth/authClient";
import { BetterAuthError } from "../utils";
import type { UpdateSsoProviderInput } from "./schemas";
import { SSO_PROVIDERS_QUERY_KEY } from "./useSsoProviders";

export function useUpdateSsoProvider(
  options?: UseMutationOptions<unknown, BetterAuthError, UpdateSsoProviderInput, unknown>,
) {
  const queryClient = useQueryClient();
  const { onSuccess, ...rest } = options ?? {};

  return useMutation({
    ...rest,
    mutationFn: async (input: UpdateSsoProviderInput) => {
      const { data, error } = await authClient.sso.updateProvider(input);
      if (error) {
        throw new Error(betterAuthErrorText(error, "Could not update SSO provider"));
      }
      return data;
    },
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({
        queryKey: SSO_PROVIDERS_QUERY_KEY,
        refetchType: "all",
      });
      onSuccess?.(...args);
    },
  });
}
